"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var img_1 = __importDefault(require("../img"));
/**
 * 设置 img src
 * @params
 * @onload img onload 时的回调函数
 */
function createImg(onload, src) {
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = onload;
    img.onerror = function () {
        img.src = getRandomImgSrc();
    };
    if (src) {
        // 如果用户设置图片则使用
        if (typeof src === 'string') {
            img.src = src;
        }
        else if (Array.isArray(src)) {
            img.src = src[(0, utils_1.getRandomNumberByRange)(0, src.length - 1)];
        }
    }
    else {
        img.src = getRandomImgSrc();
    }
    return img;
}
exports.default = createImg;
function getRandomImgSrc() {
    return img_1.default[(0, utils_1.getRandomNumberByRange)(0, img_1.default.length - 1)];
}
